module.exports = __webpack_public_path__ + "assets/img/recordIcon7.a2c95ed0.png";